const photoLocations = [
  { name: "CVS Pharmacy", link: "https://www.cvs.com/store-locator/", note: "Walk-in passport photos at most Wisconsin locations" },
  { name: "Walgreens", link: "https://www.walgreens.com/storelocator", note: "Appointment recommended, walk-ins accepted" },
  { name: "UPS Store", link: "https://www.theupsstore.com/tools/find-a-store", note: "Also handles overnight shipping of documents" },
  { name: "FedEx Office", link: "https://www.fedex.com/en-us/shipping/store/locator.html", note: "Photos + shipping in one stop" },
  { name: "Walmart", link: "https://www.walmart.com/store-finder", note: "Photo center at select Wisconsin locations" },
];

const airports = [
  { code: "MKE", name: "Milwaukee Mitchell International", address: "5300 S Howell Ave, Milwaukee, WI 53207", link: "https://www.mitchellairport.com/" },
  { code: "MSN", name: "Dane County Regional (Madison)", address: "4000 International Ln, Madison, WI 53704", link: "https://www.msnairport.com/" },
  { code: "GRB", name: "Green Bay Austin Straubel", address: "2077 Airport Dr, Green Bay, WI 54313", link: "https://www.flygrb.com/" },
  { code: "CWA", name: "Central Wisconsin Airport", address: "1100 W. Airport Dr, Mosinee, WI 54455", link: "https://www.flycwa.com/" },
  { code: "EAU", name: "Chippewa Valley Regional (Eau Claire)", address: "3800 Starr Ave, Eau Claire, WI 54703", link: "https://www.cviatc.com/" },
  { code: "LSE", name: "La Crosse Regional", address: "2850 Airport Rd, La Crosse, WI 54603", link: "https://www.flylse.com/" },
];

const shippingOptions = [
  { name: "FedEx", locator: "https://www.fedex.com/en-us/shipping/store/locator.html", note: "Priority Overnight for document submission" },
  { name: "UPS", locator: "https://www.theupsstore.com/tools/find-a-store", note: "Next Day Air Early AM available" },
  { name: "USPS", locator: "https://tools.usps.com/find-location.htm", note: "Priority Mail Express with tracking" },
];

export default function WisconsinStateResources() {
  return (
    <section id="resources" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">State Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Wisconsin Passport Resources
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Everything Wisconsin travelers need — photo locations, shipping options, airports, vital records, and the nearest regional passport agency.
          </p>
        </div>

        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-camera-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Passport Photo Locations</h3>
              <p className="text-gray-400 text-xs">Find a location near you — most offer walk-in service</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {photoLocations.map((loc, i) => (
              <a
                key={i}
                href={loc.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200"
              >
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-[#1A365D] text-sm">{loc.name}</h4>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{loc.note}</p>
              </a>
            ))}
          </div>
          <div className="mt-4 bg-[#FEF9E7] border border-[#F6C344]/20 rounded-lg p-4 flex items-start gap-3">
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-[#F6C344] text-lg"></i>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              <strong className="text-[#1A365D]">Photo requirements:</strong> 2×2 inches, white or off-white background, taken within the last 6 months. A bad photo is the #1 reason passport applications get delayed — always verify before submitting.
            </p>
          </div>
        </div>

        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-flight-takeoff-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Major Wisconsin Airports</h3>
              <p className="text-gray-400 text-xs">Verify passport validity before booking international flights</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {airports.map((ap, i) => (
              <a
                key={i}
                href={ap.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200"
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <span className="bg-[#1A365D] text-white text-xs font-bold px-2 py-0.5 rounded">{ap.code}</span>
                    <h4 className="font-semibold text-[#1A365D] text-sm">{ap.name}</h4>
                  </div>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{ap.address}</p>
              </a>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-building-2-line text-[#1A365D] text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">Chicago Regional Passport Agency</h3>
                <p className="text-gray-400 text-xs">Nearest agency — for emergencies &amp; travel within 14 days</p>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">230 S Dearborn St, Suite 2500<br/>Chicago, IL 60604</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">877-487-2778</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Mon–Fri 8:00 AM – 3:00 PM (appointment required)</p>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <p className="text-gray-500 text-xs leading-relaxed">
                Wisconsin has no state-level regional passport agency. The Chicago Passport Agency serves all Wisconsin residents. Using an approved courier like Fast Passport Center is often faster and more convenient than driving to Chicago — especially from Madison (2.5 hrs), Green Bay (3.5 hrs), or Eau Claire (4 hrs).
              </p>
            </div>
          </div>

          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-file-list-3-line text-[#1A365D] text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">Wisconsin Vital Records</h3>
                <p className="text-gray-400 text-xs">Birth certificates for passport applications</p>
              </div>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              First-time passport applicants need a certified birth certificate. Wisconsin birth records can be ordered through the Wisconsin Department of Health Services Vital Records Office.
            </p>
            <a
              href="https://www.dhs.wisconsin.gov/vitalrecords/birth.htm"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Order Wisconsin Birth Certificate <i className="ri-external-link-line"></i>
            </a>
            <div className="mt-4 pt-4 border-t border-gray-200 space-y-2">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Processing typically 2–4 weeks</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-money-dollar-circle-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">$20 per certified copy + shipping</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-truck-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Shipping &amp; Document Delivery</h3>
              <p className="text-gray-400 text-xs">Overnight options for getting documents to the processing center fast</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {shippingOptions.map((ship, i) => (
              <a
                key={i}
                href={ship.locator}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200"
              >
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-[#1A365D] text-sm">{ship.name}</h4>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{ship.note}</p>
              </a>
            ))}
          </div>
        </div>

        <div className="bg-[#0F2240] rounded-lg p-6 md:p-8 text-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 mx-auto mb-4">
            <i className="ri-lightbulb-line text-[#F6C344] text-xl"></i>
          </div>
          <h4 className="font-bold text-white text-base mb-2">Pro Tip for Wisconsin Travelers</h4>
          <p className="text-white/70 text-sm max-w-2xl mx-auto leading-relaxed">
            Wisconsin has no regional passport agency — the Chicago Passport Agency is the nearest option for all Wisconsin residents. Distances range from 65 miles (Racine) to 200 miles (Green Bay) or more. Fast Passport Center's courier service means you never have to make the roundtrip drive. The busiest travel season for Wisconsin residents is June through August (summer lake vacations, international destinations) and December through January (winter getaways). If you plan to travel during these months, start your expedited application at least 6 weeks early. Milwaukee (MKE) is the primary international departure airport for most Wisconsin travelers, with O'Hare (ORD) as the major international hub accessible to southern Wisconsin.
          </p>
        </div>
      </div>
    </section>
  );
}